var React = require('react');

function MenuAlePreowned (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.716 11.8754V2.06819C21.716 0.934022 20.782 0 19.6478 0H6.30465C5.70421 0 5.10376 0.266863 4.70347 0.733874L0.500369 5.60413C-0.16679 6.40472 -0.16679 7.53889 0.500369 8.27277L4.70347 13.2097C5.10376 13.6768 5.70421 13.9436 6.30465 13.9436H19.6478C20.782 13.9436 21.716 13.0096 21.716 11.8754ZM2.56856 7.00517C2.56856 6.07114 3.30244 5.33727 4.23646 5.33727C5.17048 5.33727 5.90435 6.07114 5.90435 7.00517C5.90435 7.93919 5.17048 8.67306 4.23646 8.67306C3.30244 8.60635 2.56856 7.87247 2.56856 7.00517Z","fill":"white"}));
}

MenuAlePreowned.defaultProps = {"width":"22","height":"14","viewBox":"0 0 22 14","fill":"none"};

module.exports = MenuAlePreowned;

MenuAlePreowned.default = MenuAlePreowned;
